import BigLogo from "@publicPortal/components/bigLogo/BigLogo";
import Board from "@publicPortal/components/board/Board";
import ResultBoard from "@publicPortal/components/resultBoard/ResultBoard";
import { PublicPortalRoutingService } from "@publicPortal/services/PublicPortalRoutingService";
import LoginBoilerplate from "@mirage/components/login/LoginBoilerplate";
import { UserService } from "@publicPortal/services/UserService";
import { useState } from "react";
import PublicLoginButtons from "./PublicLoginButtons";

const PublicLogin = () => {
    const userService = new UserService();
    const [showResultBoard, setShowResultBoard] = useState(false);
    const [emailAddress, setEmailAddress] = useState("");
    const pp = new PublicPortalRoutingService();

    const errorHandler = (error: string, email: string, serverValidationHandler: (error: string, passed: boolean) => void) => {
        if (error === "Email is not confirmed.") {
            setEmailAddress(email);
            setShowResultBoard(true);
        } else {
            serverValidationHandler(error, false);
        }
    };

    const loginBoard = (
        <Board headerText="Sign in" size="small" data-testid="publicportal-login-component">
            <LoginBoilerplate
                appName="publicportal"
                Buttons={PublicLoginButtons}
                navigateTo={pp.Root}
                service={userService}
                fieldSize={"medium"}
                customErrorHandler={errorHandler}
            />
        </Board>
    );

    const resultBoard = (
        <ResultBoard headerText="Login" loading={false} success={false} buttonLabel={"Back to Main Page"} buttonNavTo={pp.Root} message={"Your email is not confirmed."}>
            <p>We have sent confirmation email to:</p>
            <b>{emailAddress}</b>
            <p>Please check your inbox to continue.</p>
        </ResultBoard>
    );

    return (
        <>
            <BigLogo />
            {showResultBoard ? resultBoard : loginBoard}
        </>
    );
};

export default PublicLogin;
